/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import Modal from '@carvana/showroom-modal';
import PrimaryButton from '@carvana/showroom-forms/Button/Primary';
import TertiaryButton from '@carvana/showroom-forms/Button/Tertiary';
import TextArea from '@carvana/showroom-forms/Input/TextArea';
import { Form } from 'formik';

const PreOrderModal = styled(Modal)`
  .modal--content {
    background: var(--cvna-color-white);
    text-align: center;
  }

  .modal--scroll-area {
    margin: 0;
  }
`;

const PreOrderModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 44px 24px 48px;
`;

const CancellationForm = styled(PreOrderModalContent as any)``;

const BodyHeader = styled.h2`
  color: var(--cvna-color-blue-6);
  text-transform: uppercase;
  font-weight: 700;
  font-size: 28px;
  line-height: 28px;
  text-transform: uppercase;
  margin-bottom: 24px;
`;

const BodyText = styled.p`
  color: var(--cvna-color-grey-5);
  margin-bottom: 16px;
  max-width: 280px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  &:last-of-type {
    margin-bottom: 24px;
  }

  // For desktop - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    max-width: 404px;
  }
`;

const ConfirmationText = styled(BodyText as any)`
  margin-top: 8px;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
`;

const CancellationSuccess = styled(PreOrderModalContent as any)``;

const IconContainer = styled.div`
  margin-bottom: 46px;
`;

const CancellationFailure = styled(PreOrderModalContent as any)``;

const CustomForm = styled(Form as any)`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const CustomTextArea = styled(TextArea)`
  max-width: 448px;
  margin-bottom: 24px;

  & textarea {
    padding: 8px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
  }

  & .input__caption {
    display: none;
  }

  // For desktop - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    margin-bottom: 32px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;

  & > button:first-of-type {
    margin-bottom: 8px;
  }

  // For desktop - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    flex-direction: row;
    justify-content: center;
    & > button:first-of-type {
      margin-bottom: 0;
    }
  }
`;

const CustomPrimaryButton = styled(PrimaryButton)`
  width: 100%;
  min-width: unset !important;
  min-height: 48px !important;
  padding: 0 18px !important;
  font-size: 14px !important;
  line-height: 16px !important;

  // For desktop - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    max-width: 260px;
  }
`;

const CustomTertiaryButton = styled(TertiaryButton)`
  width: 100%;
  min-width: unset;
  min-height: 48px !important;
  padding: 0 !important;
  font-size: 14px !important;
  line-height: 16px !important;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    margin-left: 24px !important;
    max-width: 260px;
  }
`;

export {
  PreOrderModal,
  PreOrderModalContent,
  CancellationForm,
  BodyHeader,
  BodyText,
  ConfirmationText,
  CancellationSuccess,
  IconContainer,
  CancellationFailure,
  CustomForm,
  CustomTextArea,
  ButtonContainer,
  CustomPrimaryButton,
  CustomTertiaryButton,
};
